import * as v from 'valibot';

function nullishToUndefinedable<
  TWrapped extends v.BaseSchema<unknown, unknown, v.BaseIssue<unknown>>,
  TDefault extends v.Default<TWrapped, null | undefined>,
>(wrapped: TWrapped, defaultValue?: TDefault) {
  return v.optional(
    v.pipe(
      v.nullish(wrapped, defaultValue),
      v.transform(val => (val === null ? undefined : val)),
    ),
  );
}

export const IdentitySchema = v.object({
  identity: nullishToUndefinedable(
    v.object(
      {
        creditScore: v.nullable(v.number('creditScore must be a number when provided')),
        approvalOdds: nullishToUndefinedable(
          v.string('approvalOdds must be a string when provided'),
        ),
      },
      'identity must be a valid object',
    ),
  ),
  rawIdentity: nullishToUndefinedable(
    v.object(
      {
        data: v.object(
          {
            identity: v.object(
              {
                id: nullishToUndefinedable(v.string('id must be a string when provided')),
                is_nerdwallet_plus_member: v.nullish(
                  v.boolean('is_nerdwallet_plus_member must be a boolean when provided'),
                  false,
                ),
                roles: v.nullish(
                  v.array(v.string('role must be a string'), 'roles must be an array of strings'),
                  [],
                ),
                shea_id: nullishToUndefinedable(v.string('shea_id must be a string when provided')),
                email: nullishToUndefinedable(v.string('email must be a string when provided')),
              },
              'identity must be a valid object',
            ),
          },
          'data must be a valid object',
        ),
      },
      'rawIdentity must be a valid object',
    ),
  ),
});
